import taxonomyAPIFactory from "../taxonomy/api"

const api = taxonomyAPIFactory({ taxonomyId: 'therapeutic-goal' })

export default api